// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__28XpU","additionalInfo":"AgreementModal_additionalInfo__oyKoz"};